import {useEffect, useState} from "react";

export const useReadyEffect = (callback: () => void, deps: any[] = [], states = ['complete'], delay = 100) => {
	// run when document state is one from status, also subscribe for events

	const [isFinished, setIsFinished] = useState(false);

	useEffect(() => {
		const check = () => {
			if (states.includes(document.readyState) && !isFinished)
			{
				console.debug(`Running ready effect, state: ${document.readyState}`);
				setIsFinished(true);
				setTimeout(() => callback(), delay);
			}
		}

		if (!isFinished)
		{
			check();

			document.addEventListener('readystatechange', check);

			return () => {
				document.removeEventListener('readystatechange', check);
			}
		}
	}, [...deps, isFinished]);
}